@if ( !anyErrors ) {
<div *ngIf="responseType == 2" class="check-container mb-3">
  <app-feather-icons [icons]="'check'"></app-feather-icons>
</div>
<h2 class="mb-3">
  {{ "hello" | translate }} <b>{{ participantName }} {{ participantSurname }}</b
  >,
</h2>
<!-- responseType == 1 -->
<p *ngIf="responseType == 1" class="mb-3 mt-1" [innerHTML]="getHtml('register.qr_code_viewer_response_type_1')"></p>
<!-- responseType == 2 -->
<p *ngIf="responseType == 2" class="mb-3 mt-1" [innerHTML]="getHtml('register.qr_code_viewer_response_type_2')"></p>
<!-- responseType == 3 -->
<p *ngIf="responseType == 3" class="mb-3 mt-1" [innerHTML]="getHtml('register.qr_code_viewer_response_type_3')"></p>

<div class="row">
  <div class="col-12 col-lg-6">
    <!-- responseType == 1 -->

    <div *ngIf="responseType == 1" class="w-100">
      <img class="img-qr-code" [src]="qrCodeDataUrl" alt="download-qr-code" />
    </div>
    <div *ngIf="responseType == 1" class="row m-0 gap-3">
      <button
        class="col-12 col-md-auto btn btn-primary"
        (click)="downloadQrCode()"
      >
        {{ "button_labels.download_qr" | translate }}
      </button>
    </div>
    <!-- responseType == 2 -->

    <div
      style="
        padding: 30px 15px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      "
      [ngStyle]="{ 'background-image': 'url(' + (exclusiveContent?.bg_url ?? '') + ')' }"
      *ngIf="responseType == 2"
      class="w-100 mt-4"
    >
      <h3 style="color: white">{{ exclusiveContent?.title ?? ''}}</h3>
      <p style="color: white" class="mt-3">
        {{ exclusiveContent?.description ?? ''}}
      </p>
      <div class="mt-2">
        <button
          class="btn btn-secondary tracking-normal"
          type="button"
          (click)="handleClickExclusiveContent(exclusiveContent?.cta_url ?? '')"
          >{{ exclusiveContent?.cta_label ?? ''}}</button
        >
      </div>
    </div>
    <!-- responseType == 3 -->

    <div
      style="
        padding: 30px 15px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      "
      [ngStyle]="{ 'background-image': 'url(' + (exclusiveContent?.bg_url ?? '') + ')' }"
      *ngIf="responseType == 3"
      class="w-100"
    >
      <h3 style="color: white">{{ exclusiveContent?.title ?? ''}}</h3>
      <p style="color: white" class="mt-2">
        {{ exclusiveContent?.description ?? ''}}
      </p>
      <div class="mt-2">
        <button
          class="btn btn-secondary tracking-normal"
          type="button"
          (click)="handleClickExclusiveContent(exclusiveContent?.cta_url ?? '')"
          >{{ exclusiveContent?.cta_label ?? ''}}</button
        >
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-6">
    <div
      *ngIf="responseType == 1 || responseType == 2"
      class="p-20 details-box-event"
      style="background-color: #f7f3f2"
    >
      <div>
        <h3>
          <b>{{ 'events.detail_event' | translate }}</b>
        </h3>
      </div>
      <div class="mt-3">
        <p>
            {{ storeName ? storeName : "" }}
        </p>
      </div>
      <div class="mt-3">
        <i class="icon-location-pin"></i
        ><span style="margin-left: 5px">{{ eventAddress }}</span>
      </div>
      <div class="mt-3">
        <div *ngFor="let item of eventDates">
          <i class="icon-calendar"></i
          ><span style="margin-left: 5px; margin-bottom: 5px"
            >{{ item.date }} - {{ item.start }}</span
          >
        </div>
      </div>
    </div>
    <div
      *ngIf="responseType == 3"
      class="p-20 details-box-event"
      style="background-color: #f7f3f2"
    >
      <div *ngIf="responseType == 3" class="w-100">
        <h3>{{ yourOpinion?.title ?? ''}}</h3>
        <p class="mt-2">{{ yourOpinion?.description ?? ''}}</p>
        <div class="mb-2">
          <button
            class="btn btn-primary"
            type="button"
            (click)="handleClickYourOpinion(yourOpinion?.cta_url ?? '')"
            >{{ yourOpinion?.cta_label ?? ''}}</button
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="w-100 mt-5" *ngIf="responseType == 3 && awards">
  <div class="d-flex w-100">
    <div
      class="bg-image w-50"
      [ngStyle]="{ 'background-image': 'url(' + (awards?.bg_url ?? '') + ')' }"
    ></div>
    <div class="text-container w-50">
      <h3 style="color: white">{{ awards?.title ?? ''}}</h3>
      <p style="color: white" class="mt-2">{{ awards?.description ?? ''}}</p>
      <div class="mb-2">
        <button
          class="btn btn-secondary"
          type="button"
          (click)="handleClickAwards(awards?.cta_url ?? '')"
          >{{ awards?.cta_label ?? ''}}</button
        >
      </div>
    </div>
  </div>
</div>
}
